import { Controller } from 'react-hook-form';
import { ToggleInput, InputText, IconInfo, Select } from '@ui/src';
import { RateRequestFormTypes } from './types';

import cn from './rate-request.module.css';

const RateRequestForm = ({
  control,
  errors,
  currencyFrom,
  currencies,
  general,
  isEditable,
  onStatusChange,
  changeStatusInProgress,
  rateId,
}: RateRequestFormTypes) => (
  <div className={cn.rateRequestFormContent}>
    <div className={cn.rateRequestActiveWrapper}>
      <Controller
        control={control}
        defaultValue={false}
        name="active"
        render={({ field: { value, name, onChange } }) => (
          <ToggleInput
            name={name}
            checked={value}
            title="Active settings"
            onChange={(e) => {
              if (onStatusChange) {
                if (rateId) {
                  onStatusChange(e.target.checked);
                }
              } else {
                onChange(e.target.checked);
              }
            }}
            disabled={!isEditable || changeStatusInProgress}
          />
        )}
      />
      <div className={cn.hintWrapper}>
        <IconInfo width={16} height={16} />
      </div>
    </div>
    {!general && (
      <div className={cn.currenciesWrapper}>
        <div className={cn.currency}>
          <Controller
            control={control}
            defaultValue=""
            name="exchangeCurrencyFromId"
            render={({ field: { onChange, value, name } }) => (
              <Select
                name={name}
                onChange={onChange}
                value={value}
                list={
                  currencies?.map((item) => ({
                    name: item.name,
                    value: item.id,
                  })) || []
                }
                placeholder="Select currency"
                title="Currency from"
                error={errors?.exchangeCurrencyFromId?.message}
                disabled={Boolean(rateId)}
                fullWidth
              />
            )}
          />
        </div>
        <div className={cn.currency}>
          <Controller
            control={control}
            defaultValue=""
            name="exchangeCurrencyToId"
            render={({ field: { onChange, value, name } }) => (
              <Select
                name={name}
                onChange={onChange}
                value={value}
                list={
                  currencies
                    ?.filter((item) => item.id !== currencyFrom)
                    ?.map((item) => ({
                      name: item.name,
                      value: item.id,
                    })) || []
                }
                placeholder="Select currency"
                title="Currency to"
                error={errors?.exchangeCurrencyToId?.message}
                disabled={!currencyFrom || Boolean(rateId)}
                fullWidth
              />
            )}
          />
        </div>
      </div>
    )}
    <div className={cn.formGroup}>
      <Controller
        control={control}
        name="maxDeviationPercent"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            placeholder=""
            name={name}
            value={value}
            title="Max. request deviation"
            onChange={onChange}
            error={errors?.maxDeviationPercent?.message}
            className={cn.inputWithSuffix}
            suffix="%"
            disabled={!isEditable}
            currency={currencies?.find((item) => item.id === currencyFrom)}
            min={1}
            withoutMinDigits
            amountInput
          />
        )}
      />
    </div>
  </div>
);

export default RateRequestForm;
